export default "__VITE_ASSET__Cyt9SB2w__"